import { render, staticRenderFns } from "./create-extra.vue?vue&type=template&id=9039de4c&scoped=true&"
import script from "./create-extra.vue?vue&type=script&lang=js&"
export * from "./create-extra.vue?vue&type=script&lang=js&"
import style0 from "./create-extra.vue?vue&type=style&index=0&id=9039de4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9039de4c",
  null
  
)

export default component.exports